import React from 'react';
import './weddingContractInput.scss'
import Checkbox from '@src/components/common/checkbox/Checkbox';
const WeddingContractInput = ({clickHandler, checkedHandler, checked}) => {
    return (
        <div className={`contract-input-wrap  ${checked? 'agree' :''}`}  onClick={clickHandler}>
            <input type='checkbox'  className='input-checkbox'
                checked={checked}
                onClick={(e) => {
                    if(checked === true){
                        e.stopPropagation()
                    }
                    checkedHandler()
                }} />
            <span className='contract-name'>예식계약서</span>
            <i className='icon icon-chevron-right-18-black'/>
        </div>
    );
};

export default WeddingContractInput;